import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { changePermissionFailure, changePermissionSuccess } from "domains/createShareSettings/actions";
import type { ChangeInvitePermissionDefaultAction } from "domains/createShareSettings/actionTypes";
import { activateModal } from "domains/modal/actions";
import type { TopicAccessPatch } from "domains/topicshare/topicshare.types";

export function* changePermissionSaga(action: ChangeInvitePermissionDefaultAction) {
  const { email, permission, topic_id } = action.meta;
  try {
    const body: TopicAccessPatch = { permission };
    yield apiFetch(`topic/${topic_id}/access/email/${email}`, { body, method: "PATCH" });
    yield put(changePermissionSuccess(action.meta));
  } catch {
    yield put(changePermissionFailure(action.meta));
    yield put(activateModal({ id: "Error" }));
  }
}
